import React from "react";
import { useNavigate } from "react-router-dom";
import Hero from "../../components/Hero/Hero";
import MenuCategories from "../../components/MenuCategories/MenuCategories";
import Footer from "../../components/Footer/Footer";
import {
  heroContent,
  menuCategoriesContent,
  footerContent,
} from "../../config/textContent";

const HomePage = () => {
  const navigate = useNavigate();
  const handleCategorySelect = (categoryId) => {
    navigate(`/menu/${categoryId}`);
  };

  return (
    <div className="home-page">
      <Hero title={heroContent.title} subtitle={heroContent.subtitle} />
      <MenuCategories
        title={menuCategoriesContent.sectionTitle}
        categories={menuCategoriesContent.categories}
        onCategorySelect={handleCategorySelect}
      />
      <Footer
        address={footerContent.address}
        phone={footerContent.phone}
        email={footerContent.email}
        mapLink={footerContent.mapLink}
        socialLinks={footerContent.socialLinks}
        companyName={footerContent.companyName}
        workingHours={footerContent.workingHours}
      />
    </div>
  );
};

export default HomePage;
